<template>
    <a :href="item.url" class="news-item news-item--small" :title="item.title">
        <figure class="news-item__figure">
            <picture>
                <source
                    media="(min-width: 1440px)"
                    :srcset="`${item.imageUrl}?height=904&format=webp&quality=80&mq-min=1024`"
                    type="image/webp" />
                <source
                    media="(min-width: 1024px)"
                    :srcset="`${item.imageUrl}?height=628&format=webp&quality=80&mq-min=1024`"
                    type="image/webp" />
                <source
                    media="(max-width: 390px)"
                    :srcset="`${item.imageUrl}?height=140&format=webp&quality=80&mq-max=390`"
                    type="image/webp" />
                <img loading="lazy" :src="item.imageUrl" :alt="item.title" />
            </picture>
        </figure>

        <div class="news-item__body">
            <div class="sub-header">{{ formattedDate }}</div>
            <header class="title">{{ item.title }}</header>
        </div>
    </a>
</template>

<script setup lang="ts">
import { INewsArticle } from '../model/news-overview.model';
import { useDateFormatter } from '../../../composables/useDateFormatter';

const props = defineProps<{
    item: INewsArticle;
}>();

const formattedDate = useDateFormatter(props.item.publishDate);
</script>
